import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import "./style.scss";
import BuildingBlueSquare from "../../../icons/BuildingBlueSquare";
import GreenTimerSquare from "../../../icons/GreenTimerSquare";
import MileagePurpleSquare from "../../../icons/MileagePurpleSquare";
import { useDispatch, useSelector } from "react-redux";
import { getCpaClientList } from "../../../core/data/redux/user/_userAction";
import {
  getStorageItem,
  setStorageItem,
} from "../../../services/storage.service";
import { getCpaDashoard } from "../../../core/data/redux/dashboard/_dashboardAction";
import MileageDashboardList from "../../../core/components/common/mileageDashboardList";
import LoggedHoursDashboardList from "../../../core/components/common/loggedHoursDashboardList";
import { formatDateAgo } from "../../../constants/date";
import { capitalizeFullName } from "../../../constants/common";

const CpaDashboard = () => {
  const { isSidebarOpen } = useOutletContext<{
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
  }>();
  const dispatch: any = useDispatch();

  const cpaClients = useSelector((state: any) => state?.user);
  const cpaClientlist = cpaClients?.cpaClientlist;
  const cpaDashboardState = useSelector((state: any) => state?.dashboard);
  const dashboardData = cpaDashboardState?.cpaDashoard;

  const [selectedClient, setSelectedClient] = useState<string | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedClientName, setSelectedClientName] = useState<string>("");

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(getCpaClientList({}));
    // fetchDashboardData();
  }, [dispatch]);

  // Helper: Check if a client is active
  const isClientActive = (client: any) => {
    return client?.is_active && client?.plan_name?.toLowerCase() !== "basic";
  };

  // Filter only active clients
  const activeClients = cpaClientlist.filter(isClientActive);

  useEffect(() => {
    if (cpaClientlist.length === 0) return;

    const storedUuid = getStorageItem("selectedClientUuid");
    let clientToSelect: any = null;

    // Step 1: Try to restore from storage (only if still active)
    if (storedUuid) {
      const storedClient = cpaClientlist.find(
        (c: any) => c.uuid === storedUuid
      );
      if (storedClient && isClientActive(storedClient)) {
        clientToSelect = storedClient;
      }
    }

    // Step 2: If no valid stored client, pick the first active one
    if (!clientToSelect && activeClients.length > 0) {
      clientToSelect = activeClients[0];
    }

    // Step 3: Update state and storage only if we have a valid active client
    if (clientToSelect) {
      const uuid = clientToSelect.uuid;
      const name =
        clientToSelect.first_name || clientToSelect.name || "Unknown";

      setStorageItem("selectedClientUuid", uuid);
      setSelectedClient(uuid);
      setSelectedClientName(name);
    } else {
      // Optional: handle case where no active clients exist
      setSelectedClient(null);
      setSelectedClientName("No active client available");
    }
  }, [cpaClientlist]);

  useEffect(() => {
    if (selectedClient) {
      dispatch(getCpaDashoard({ owner_uuid: selectedClient }));
    }
  }, [selectedClient, dispatch]);

  const handleClientSelect = (client: any) => {
    if (!isClientActive(client)) return; // Safety (though UI prevents this)

    setSelectedClient(client.uuid);
    setSelectedClientName(client.first_name || client.name);
    setStorageItem("selectedClientUuid", client.uuid);
    setIsDropdownOpen(false);
  };

  // useEffect(() => {
  //   if (cpaClientlist && cpaClientlist.length > 0) {
  //     const storedUuid = getStorageItem("selectedClientUuid");
  //     let selectedUuid: string | null = null;
  //     let selectedName = "";

  //     if (storedUuid) {
  //       const matchingClient = cpaClientlist.find((client: any) => client.uuid === storedUuid);
  //       if (matchingClient) {
  //         selectedUuid = matchingClient.uuid;
  //         selectedName = matchingClient.first_name;
  //       }
  //     }

  //     if (!selectedUuid) {
  //       selectedUuid = cpaClientlist[0].uuid;
  //       selectedName = cpaClientlist[0].first_name;
  //     }

  //     setStorageItem("selectedClientUuid", selectedUuid);
  //     setSelectedClient(selectedUuid);
  //     setSelectedClientName(selectedName);
  //   }
  // }, [cpaClientlist]);

  // useEffect(() => {
  //   if (selectedClient) {
  //     setStorageItem("selectedClientUuid", selectedClient);
  //     setSelectedClient(selectedClient);
  //     fetchDashboardData();
  //   }
  // }, [selectedClient]);

  // const fetchDashboardData = async () => {
  //   await dispatch(getCpaDashoard({ owner_uuid: selectedClient }));
  // };

  return (
    <div className="layout">
      <Sidebar isOpen={isSidebarOpen} />

      <main className="content">
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8"
          ref={dropdownRef}
        >
          <div className="dropdown log-hour-list-page-dropdown cpa-dashboard-search m-2">
            <button
              className="form-select d-flex justify-content-between align-items-center form-control commonInput"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              disabled={activeClients.length === 0}
            >
              {selectedClientName || "Select Client"}
              <i
                className={`bi bi-chevron-${isDropdownOpen ? "up" : "down"}`}
              />
            </button>

            {isDropdownOpen && (
              <div
                className="dropdown-menu proprty-dropdown show w-100 p-3 shadow-sm mt-1 bg-light"
                style={{ maxHeight: "initial" }}
              >
                {cpaClientlist?.length > 0 ? (
                  cpaClientlist.map((client: any, index: number) => (
                    <div
                      key={client?.uuid || index}
                      // className="property-drop form-check d-flex align-items-left mb-3 justify-content-between form-control commonInput bg-light"
                      // onClick={() => {
                      //   setSelectedClient(client?.uuid);
                      //   setSelectedClientName(client?.first_name);
                      //   setIsDropdownOpen(false);
                      // }}
                      // style={{ cursor: "pointer" }}
                      className={`property-drop form-check d-flex align-items-left mb-3 justify-content-between form-control commonInput bg-light ${
                        !isClientActive(client) ? "text-muted opacity-50" : ""
                      }`}
                      onClick={() => handleClientSelect(client)}
                      style={{
                        cursor: isClientActive(client)
                          ? "pointer"
                          : "not-allowed",
                        pointerEvents: isClientActive(client) ? "auto" : "none",
                      }}
                    >
                      <label className="form-check-label ms-2">
                        <div className="label-inner-content d-flex flex-column gap-2">
                          <strong>
                            {capitalizeFullName(client?.first_name)}{" "}
                            {capitalizeFullName(client?.last_name)}
                          </strong>
                          {/* <small className="text-muted d-flex align-items-center">
                            {capitalizeFullName(client?.first_name)} {capitalizeFullName(client?.last_name)}
                          </small> */}
                        </div>
                        <span>
                          {client?.is_active &&
                          client?.plan_name?.toLowerCase() !== "basic"
                            ? "Active"
                            : "Inactive"}
                        </span>
                      </label>
                      <input
                        type="radio"
                        className="form-check-input mt-1"
                        name="propertyRadio"
                        checked={selectedClient === client?.uuid}
                        readOnly
                      />
                    </div>
                  ))
                ) : (
                  <div className="text-muted text-center">
                    No results found.
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="profileSettings spousePages">
          <div className="gap-3 mb-4">
            <h2>Dashboard</h2>
            <p>Manage assigned properties and track your contributions</p>
          </div>

          <div className="fourBlocks">
            <div className="row align-items-stretch">
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 d-flex mb-3">
                <div className="blockWrapper w-100 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                  <div className="d-flex flex-column gap-2">
                    <label>Total Properties</label>
                    <strong className="blueText">
                      {dashboardData?.total_assigned_properties || "0"}
                    </strong>
                  </div>
                  <BuildingBlueSquare />
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 d-flex mb-3">
                <div className="blockWrapper w-100 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                  <div className="d-flex flex-column gap-2">
                    <label>Total Hours</label>
                    <strong className="greenText">
                      {dashboardData?.total_logged_hours || "0"}
                    </strong>
                  </div>
                  <GreenTimerSquare />
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 d-flex mb-3">
                <div className="blockWrapper w-100 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                  <div className="d-flex flex-column gap-2">
                    <label>Total Mileage</label>
                    <strong className="purpleText">
                      {dashboardData?.total_mileage || "0"}
                    </strong>
                  </div>
                  <MileagePurpleSquare />
                </div>
              </div>
            </div>
          </div>

          <div className="loggedHoursBlock">
            <LoggedHoursDashboardList
              data={dashboardData?.recent_logged_hours}
            />
          </div>

          <div className="mileageBlock">
            <MileageDashboardList data={dashboardData?.mileage} />
          </div>

          <div className="recentEntroesBlock">
            <h2 className="section-title">Recent Activities</h2>

            {dashboardData?.recent_activities?.length > 0 &&
              dashboardData?.recent_activities?.map(
                (entry: any, index: number) => (
                  <ul>
                    <li className="d-flex justify-content-between gap-3 align-items-center">
                      <div className="d-flex gap-3 align-items-center">
                        {entry?.model_name?.toLowerCase() === "properties" ? (
                          <GreenTimerSquare />
                        ) : (
                          <MileagePurpleSquare />
                        )}
                        <div className="d-flex flex-column">
                          <label>{entry?.details}</label>
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <span>{formatDateAgo(entry?.created_at)}</span>
                      </div>
                    </li>
                  </ul>
                )
              )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default CpaDashboard;
